import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Spazi from "@/components/landing/Spazi";
import Posizione from "@/components/landing/Posizione";
import Prenota from "@/components/landing/Prenota";
import Footer from "@/components/landing/Footer";

const Home = () => {
  return (
    <div className="bg-[#121110] text-[#f4efe8] font-sans antialiased selection:bg-[#c9944a] selection:text-black min-h-screen">
      <Nav />
      <Hero />
      <Marquee />
      <Spazi />
      <Posizione />
      <Prenota />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
